import React, { type ComponentProps } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, type TextStyle } from 'react-native';

import { theme } from '@garnish/constants';
import { Button, TextLink, useResponsive } from '@garnish/core';

export const LoyaltyPointsHistoryCtaButton = (props: LoyaltyPointsHistoryCtaButtonProps) => {
  const { palette = 'secondary', onPress } = props;

  const { match } = useResponsive();
  const { formatMessage } = useIntl();

  const label = match([formatMessage(messages.viewHistory), formatMessage(messages.pointsHistory)]);

  return (
    <Button
      size="large"
      style={styles.cta}
      palette={palette}
      accessibilityRole="button"
      accessibilityLabel={formatMessage(messages.accessibilityLabel)}
      onPress={onPress}
    >
      {label}
    </Button>
  );
};

export const LoyaltyPointsHistoryCtaLink = (props: LoyaltyPointsHistoryCtaLinkProps) => {
  const { style, onPress } = props;

  const { match } = useResponsive();
  const { formatMessage } = useIntl();

  const label = match([formatMessage(messages.viewHistory), formatMessage(messages.pointsHistory)]);

  return (
    <TextLink
      style={style}
      underline
      sizeMatch={['14']}
      accessibilityRole="button"
      accessibilityLabel={formatMessage(messages.accessibilityLabel)}
      onPress={onPress}
    >
      {label}
    </TextLink>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  cta: {
    minHeight: theme.spacing['16'],
    paddingHorizontal: theme.spacing['8'],
  },
});

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  accessibilityLabel: {
    defaultMessage: 'Open points history screen',
    description: 'Loyalty | Points History | Accessibility label',
  },
  pointsHistory: {
    defaultMessage: 'Points History + FAQ',
    description: 'Loyalty | Points History | Points history',
  },
  viewHistory: {
    defaultMessage: 'View history',
    description: 'Loyalty | Points History | View history',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type LoyaltyPointsHistoryCtaButtonProps = {
  palette?: ComponentProps<typeof Button>['palette'];
  onPress: () => void;
};

type LoyaltyPointsHistoryCtaLinkProps = {
  style?: TextStyle;
  onPress: () => void;
};
